import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Heading,
  Image,
  RadioGroup,
  Stack,
  Step,
  StepDescription,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Text,
} from "@chakra-ui/react";
import ModalRight from "../../modal-right";
import SearchBar from "../../search-bar";
import PrimaryButton from "../../primary-button";
import PrimaryInput from "../../primary-input";
import DatePicker from "../../date-picker";
import {
  addVaccination,
  deleteVacinations,
  editVaccinations,
  FetchVaccinationDetails,
  getVaccineList,
} from "../../../middleware/services/messages";
import { format } from "date-fns";
import { actionAccessMain, getLoginID } from "../../../auth";
import moment from "moment";
import DatePickerQuick from "../date-picker-quick";
import { uploadImageInProfile } from "../../../middleware/services/profile";

const NoVaccinationDataScreen = forwardRef(
  (
    {
      width,
      height,
      patientId,
      showErrorToast,
      showSuccessToast,
      showLoader,
      dismissLoader,
      fetchPatientHealthData,
      isNoData,
    },
    ref
  ) => {
    const openFromStartVisitOverview = () => {
      console.log("Function called!");
      openVaccinationsModal();
    };

    useImperativeHandle(ref, () => ({
      openFromStartVisitOverview,
    }));

    const [actionAccessPatients, setActionAccessPatients] = useState(null);
    useEffect(() => {
      setActionAccessPatients(actionAccessMain(4));
    }, []);

    const dynamicModal = React.useRef();
    const addCondition = React.useRef();
    const addCondition2 = React.useRef();

    const addCondition3 = React.useRef();

    const [data, setData] = useState("");
    var [conditionsList, setConditionsList] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [selectedDates, setSelectedDates] = useState({});
    const [selectedDueDates, setSelectedDueDates] = useState({});
    const [condition, setCondition] = useState("");
    const [vaccineid, setVaccineid] = useState("");
    const [idPatient, setIdPatient] = useState("");
    const [vaccineName, setVaccineName] = useState("");
    const [adminDate, setAdminDate] = useState("");
    const [dueDate, setDueDate] = useState("");

    const scrollDiv = useRef(null);
    const chatContainerRef = useRef(null);
    const [aianswers, setAIAnswers] = useState([]);
    const [remainingquestions, setRemainingQuestions] = useState([]);
    const [aiquestion, setAIAnalysis] = useState(null);
    const [AiInput, setAiInput] = useState(null);
    const [initialRender, setInitialRender] = useState(true);
    const [animate, setAnimate] = useState(false);
    const AIChatModel = useRef();

    const [typedCondition, setTypedCondition] = useState("");


    
    //state for document upload start ------------------------------
    const fileInputRef = useRef(null);
    const fileInputRefUpdate = useRef(null);
    
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    
    const [documentURLs, setDocumentURLs] = useState([]);
    const indexMap = {};
    const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
    const [filenameforUpload, setFilenameforUpload] = useState([]);
    //state for document upload End ------------------------------


    let patientidFromLocal = patientId;

    const fetchMedicalConditionList = async () => {
      try {
        const result = await getVaccineList({
          type: "vaccine",
          patientid: patientidFromLocal,
        });
        if (result.output.result == "success") {
          setConditionsList(result.output.data);
        } else {
          showErrorToast("Something went wrong!");
        }
      } catch (error) {
        console.error("Error", error);
      }
    };

    const handleCheckboxChange = (condition) => {
      const isSelected = selectedConditions.some(
        (item) => item.condition_cd === condition.condition_cd
      );

      if (isSelected) {
        setSelectedConditions((prevConditions) =>
          prevConditions.filter(
            (item) => item.condition_cd !== condition.condition_cd
          )
        );

        setSelectedDates((prevDates) => {
          const updatedDates = { ...prevDates };
          delete updatedDates[condition.condition_cd]; // Remove the date for the deselected condition
          return updatedDates;
        });
        setSelectedDueDates((prevDates) => {
          const updatedDates = { ...prevDates };
          delete updatedDates[condition.condition_cd]; // Remove the date for the deselected condition
          return updatedDates;
        });
      } else {
         // If the condition is not selected, add it and set the date to the first date of the current month
             const now = new Date();
             const firstDateOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
             const formattedDate = format(firstDateOfMonth, "yyyy-MM-dd");
             setSelectedDates((prevDates) => ({
              ...prevDates,
              [condition.condition_cd]: formattedDate,
            }));
            setSelectedDueDates((prevDates) => ({
              ...prevDates,
              [condition.condition_cd]: formattedDate,
            }));

        setSelectedConditions([...selectedConditions, condition]);
      }
    };
    const [minDateState, setMinDateState] = useState("");
    const [maxDateState, setMaxDateState] = useState("");
    const handleDateChange = (conditionCd, date) => {
      const formattedDate = format(date, "yyyy-MM-dd");
      setMinDateState(date);
      setSelectedDates((prevDates) => ({
        ...prevDates,
        [conditionCd]: formattedDate,
      }));
    };
    const handleDueDateChange = (conditionCd, date) => {
      setMaxDateState(date);
      const formattedDate = format(date, "yyyy-MM-dd");
      setSelectedDueDates((prevDates) => ({
        ...prevDates,
        [conditionCd]: formattedDate,
      }));
    };

    var inputForAdd = {
      patientid: patientidFromLocal,
      doctorid: getLoginID(),
      vaccination: selectedConditions.map((condition, index) => ({
        vaccine_cd: condition.condition_cd,
        vaccinename: condition.condition,
        admindate: selectedDates[condition.condition_cd] || null,
        duedate: selectedDueDates[condition.condition_cd] || null,
        "documents": uploadedDocuments
        .filter((doc) => doc.condition_cd == condition.condition_cd)
        .map(({ condition_cd, filename }) => ({
          condition_cd,
          filename,
        })),
      })),
    };

    const AddMedicalConditions = () => {
      if (selectedConditions.length === 0 && typedCondition == "") {
        showErrorToast("Please Select a Vaccine to Continue");
      } else {
        // enter manually
        if (typedCondition !== "") {
          const newSelectedCondition = {
            condition: typedCondition,
            condition_cd: null,
            conditiontype: "other",
          };

          setSelectedConditions((prevConditions) => {
            // Filter out any existing condition with the same type
            const filteredConditions = prevConditions.filter(
              (item) => item?.conditiontype !== "other"
            );
            // Add the new condition
            return [...filteredConditions, newSelectedCondition];
          });
        }

        //--------------------------------
        // setSelectedDates({});
        // setSelectedDueDates({});
        addCondition2.current.openRight();
      }
    };

    const AddMedicalConditionsCall = () => {
      const addConditions = async () => {
        showLoader();
        try {
          const result = await addVaccination(inputForAdd);
          if (result.output.result == "success") {
            showSuccessToast("Successfully Added");
            if (scrollDiv.current) {
              scrollDiv.current.scrollTop = 0;
            }

            fetchPatientHealthData();

            addCondition2.current.closeRight();
            addCondition.current.closeRight();
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error in DashboardIndex:", error);
        }
        dismissLoader();
      };

      const isDateMissing = selectedConditions.some(
        // (condition) => !selectedDates[condition.condition_cd] || !selectedDueDates[condition.condition_cd]
        (condition) => !selectedDates[condition.condition_cd]
      );

      if (isDateMissing) {
        showErrorToast("Please select admin date");
        return false;
      } else {
        addConditions();
      }
    };

    const openVaccinationsModal = () => {
      // if (conditionsList == null) {
      fetchMedicalConditionList();
      // }
      setSearchValue("");
      setSelectedConditions([]);
      setSelectedDueDates({});
      setTypedCondition("");
      addCondition.current.openRight();
    };

    const handleCondition = (e) => {
      const inputText = e.target.value;
      const maxLength = 80;

      if (inputText.length <= maxLength) {
        setTypedCondition(inputText);
      }
    };

    // upload document functionality start ------------------------------

  // ADD CODE - 
  const handleVaccineUpload = async (e) => {
    e.preventDefault();
    showLoader();
    if (e.target.files.length == 0) {
      dismissLoader();
      return;
    }
    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {

        dismissLoader();
      }, 1000);
      return false;
    }
    const condition = e.target.getAttribute('data-vaccine');
    let condition_cd = e.target.getAttribute('data-vaccine-cd');
    if (condition_cd === "null") {
      condition_cd = null
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    const result = await uploadImageInProfile(file2, file2.name);
    const filename = result.name;
    setSelectedDates((prevDates) => ({
      ...prevDates,
      [condition]: {
        // date: prevDates[condition]?.date || "",
        fileName: filename,
      },
    }));
    setUploadedDocuments((prevDocuments) => [
      ...prevDocuments,
      { condition_cd, filename },
    ]);
    e.target.value = '';
    dismissLoader();

  };


  const addVaccineUploadDocument = (condition) => {
    // alert(condition.condition_cd)
    if (condition.condition_cd) {

      fileInputRef.current.setAttribute('data-vaccine-cd', condition.condition_cd);
      fileInputRef.current.setAttribute('data-vaccine', condition.condition);
      fileInputRef.current.click();

    } else {

      fileInputRef.current.setAttribute('data-vaccine-cd', null);
      fileInputRef.current.setAttribute('data-vaccine', "other");
      fileInputRef.current.click();
    }
  }

  useEffect(() => {
    setDocumentURLs(uploadedDocuments)
  }, [uploadedDocuments])

  const handleDelete = (index) => {
    const updatedUrls = [...uploadedDocuments];
    updatedUrls.splice(index, 1);
    setUploadedDocuments(updatedUrls);
  };
  const handleDeleteDocInEdit = (index) => {
    const updatedUrls = [...documentURLForEdit];
    updatedUrls.splice(index, 1);
    // setUploadedDocuments(updatedUrls);

    setDocumentURLForEdit(updatedUrls);

    if (updatedUrls != null) {

      setFilenameforUpload(updatedUrls?.map(doc => doc.documentname));
    }
  };

  // EDIT CODE -  ----
  const updateVaccineUploadDocument = (surgery_cd) => {

    fileInputRefUpdate.current.setAttribute('data-vaccine-cd', surgery_cd);
    fileInputRefUpdate.current.click();
  }
  const handleVaccineUploadUpdate = async (e) => {
    e.preventDefault();

    const vaccine_cd = e.target.getAttribute('data-vaccine-cd');
    showLoader();
    if (e.target.files.length == 0) {
      dismissLoader();
      return;
    }
    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {

        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    const result = await uploadImageInProfile(file2, file2.name);
    const filename = result.name;

    setFilenameforUpload(prevFilenames => [...prevFilenames, filename]);
    // setDocumentURLForEdit(prevFilenames => [...prevFilenames, { documenturl: filename, imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/" }]);
    setDocumentURLForEdit(prevFilenames => [
      ...(prevFilenames ?? []),
      { documentname: filename, documenturl: filename, imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/" }
    ]);

    e.target.value = '';
    showSuccessToast("Document Added Successfully.")
    dismissLoader();

  };


  // upload document functionality End  ||


    return (
      <Box h="100%">
        <Box
          bg="#fcfcfd"
          width={width}
          height={height}
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          flexDir='column'
        h='100%'
        gap='1rem'
        >
          <PrimaryButton
            fontSize="14px"
            variant="mdBtn"
            btnIcon="/assets/imgs/add.png"
            buttonText="Add Vaccination"
            onClick={openVaccinationsModal}
            isDisabled={actionAccessPatients?.create ? false : true}
          />
          {isNoData === "Yes" &&
          <Text textAlign="center">
            No Vaccination Data Available
          </Text>
          }
        </Box>
        {/* Add Modal Here  */}
        <ModalRight
          ref={addCondition}
          header="Add vaccine"
          body={
            <>
              <SearchBar
                passInputPlace="Search condition"
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <RadioGroup>
                <Stack direction="column" gap="0">
                  <Box display="flex" justifyContent="end" w="100%">
                    <Stack direction="column" gap="0" w="100%">
                      {conditionsList && conditionsList.length > 0 ? (
                        conditionsList.some((category) =>
                          category.data.some((condition) =>
                            condition.condition
                              .toLowerCase()
                              .includes(searchValue.toLowerCase())
                          )
                        ) ? (
                          conditionsList.map((category) => (
                            <React.Fragment key={category.category_id}>
                              {category.data
                                .filter((condition) =>
                                  condition.condition
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase())
                                )
                                .map((condition) => (
                                  <label key={condition.condition_cd}>
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                      borderBottom="1px solid #e2e8f0"
                                      p="15px"
                                      pl="5px"
                                      minH="50px"
                                      width="100%"
                                      sx={{
                                        _hover: {
                                          border: "2px solid #384052",
                                          borderRadius: "10px",
                                        },
                                      }}
                                    >
                                      <Box
                                        key={condition.condition_cd}
                                        display="flex"
                                        alignItems="center"
                                      >
                                        <Text
                                          fontSize="16px"
                                          lineHeight="normal"
                                          fontWeight="600"
                                        >
                                          {/* {condition.condition} */}
                                          {condition.condition}{condition.age_range ? ` (${condition.age_range})` : ""}
                                        </Text>
                                      </Box>
                                      <Box display="flex" justifyContent="end">
                                        <Checkbox
                                          colorScheme="green"
                                          sx={{
                                            ".chakra-checkbox__control": {
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "5px",
                                            },
                                          }}
                                          onChange={() =>
                                            handleCheckboxChange(condition)
                                          }
                                          isChecked={selectedConditions.some(
                                            (item) =>
                                              item.condition_cd ===
                                              condition.condition_cd
                                          )}
                                        ></Checkbox>
                                      </Box>
                                    </Box>
                                  </label>
                                ))}
                            </React.Fragment>
                          ))
                        ) : (
                          <Box
                            p="15px"
                            fontSize="16px"
                            fontWeight="600"
                            textAlign="center"
                          >
                            No matching vaccinations found!
                          </Box>
                        )
                      ) : (
                        <p>Loading...</p>
                      )}
                      <Divider />
                      <br />
                      <Heading
                        as="h2"
                        fontSize="12px"
                        pl="5px"
                        textTransform="uppercase"
                        fontWeight="600"
                        my="10px"
                      >
                        Other Vaccination
                      </Heading>
                      <PrimaryInput
                        inputPlace="Vaccination"
                        variant="bothSide"
                        onChange={handleCondition}
                        inputValue={typedCondition}
                      />
                      <br />
                    </Stack>
                  </Box>
                </Stack>
              </RadioGroup>

              <ModalRight
                ref={addCondition2}
                header="Add Vaccination"
                body={
                  <>
                    <Box display="flex" flexDir="column" gap="20px">
                      {selectedConditions.map((condition, index) => (
                        <Box key={index}>
                          <Text fontSize="16px" py="10px" fontWeight="600">
                            {condition.condition}
                          </Text>

                          {/* <DatePicker
                            disableFutureDates={true}
                            //minDate={null}
                            maxDate={maxDateState}
                            onDateChange={(selectedDateValue) =>
                              handleDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            placeholderProp="Admin Date*"
                          /> */}

                          <DatePickerQuick
                            disableFutureDates={true}
                            // patientDOB={PatientDOB}
                            maxDate={maxDateState}
                            CUSTOM_DISABLE={true}
                            placeholderProp="Select Admin Date*"
                            // defaultDate={todaysDate}
                            onDateChange={(selectedDateValue) =>
                              handleDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            calendarStlye={{
                              transform: "scale(0.9)",
                              right: "-22px",
                              top: "30px",
                            }}
                          />

                          {/* <DatePicker
                            disablePastDates={true}
                            //minDate={minDateState}
                            onDateChange={(selectedDateValue) =>
                              handleDueDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            placeholderProp="Due Date"
                            minDate={new Date().toISOString()}
                          /> */}

                          <DatePickerQuick
                            disablePastDates={true}
                            // patientDOB={PatientDOB}
                            CUSTOM_DISABLE={true}
                            placeholderProp="Select Due Date"
                            minDate={new Date().toISOString()}
                            // defaultDate={todaysDate}
                            onDateChange={(selectedDateValue) =>
                              handleDueDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            calendarStlye={{
                              transform: "scale(0.9)",
                              right: "-22px",
                              top: "30px",
                            }}
                          />

                          
                  {/* Upload document JSX start ---------- */}
{documentURLs?.map((document, index) => {
                        if (document.condition_cd == condition.condition_cd || (document.condition_cd == null && condition.condition_cd == null)) {
                          if (!indexMap[document.condition_cd]) {
                            indexMap[document.condition_cd] = 1;
                          }
                          const docIndex = indexMap[document.condition_cd];
                          indexMap[document.condition_cd]++; // Increment index for next document with same condition_cd

                          return (
                            <Box key={index} mb="2" mt="2">
                              <Button
                                as="a"
                                rel="noopener noreferrer"
                                w="100%"
                                h="48px"
                                borderRadius="10px"
                                border="1px solid #E6E7E9"
                                display="flex"
                                justifyContent="space-between"
                                bg="white"
                                color="#1C4EC5"
                                sx={{ _hover: { bg: "none" } }}
                                style={{
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                Document {docIndex}
                                <Box as="span" onClick={() => handleDelete(index)}>
                                  <Image src="/assets/imgs/delete.png" />
                                </Box>
                              </Button>
                            </Box>
                          );
                        }
                      })}
                      <Box 
                      onClick={() => addVaccineUploadDocument(condition)} 
                      as="button" display="flex" alignItems="center" gap="10px" mt="5px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                        <Image w="11px" src="/assets/imgs/add-blue.png" />
                        Add Document
                      </Box>

                      <input
                        type='file'
                        id='file-upload'
                        onChange={(e) => handleVaccineUpload(e)}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                      />

                      
                      {/* Upload document JSX End ---------- |||||| */}
                
                        </Box>
                      ))}
                    </Box>
                  </>
                }
                footerActions={
                  <>
                    <Box w="100%" display="flex" flexDirection="row" gap="15px">
                      <PrimaryButton
                        buttonText="Add Vaccine"
                        isDisabled={actionAccessPatients?.create ? false : true}
                        onClick={AddMedicalConditionsCall}
                      />
                    </Box>
                  </>
                }
              />
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" flexDirection="row" gap="15px">
                <PrimaryButton
                  buttonText="Continue"
                  isDisabled={false}
                  onClick={AddMedicalConditions}
                />
              </Box>
            </>
          }
        />
      </Box>
    );
  }
);

export default NoVaccinationDataScreen;
